var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor",class:[
        {
            'editor--no-sidebar':
                !_vm.isConfiguratorActive &&
                !_vm.isListeditorActive &&
                !_vm.isFileeditorActive &&
                !_vm.isFilemanagerActive &&
                !_vm.isTextpickerActive,
            'editor--configurator': _vm.isConfiguratorActive,
            'editor--listeditor': _vm.isListeditorActive,
            'editor--filemanager': _vm.isFilemanagerActive,
            'editor--fileeditor': _vm.isFileeditorActive,
            'editor--settings': _vm.isSettingsActive,
            'editor--textpicker': _vm.isTextpickerActive,
            'editor--modulecreator': _vm.isModulecreatorActive,
            'editor--configurator-modules': _vm.getActiveConfiguratorGroup === 'modules',
            'editor--configurator-header':
                _vm.getActiveConfiguratorGroup === 'menus' && _vm.getActiveMenuType === 'header',
            'editor--configurator-footer':
                _vm.getActiveConfiguratorGroup === 'menus' && _vm.getActiveMenuType === 'footer'
        },
        _vm.getCurrentDeviceClass
    ]},[_c('app-header'),_c('app-page',{attrs:{"editor-mode":true}}),(_vm.isConfiguratorActive)?_c('app-configurator'):_vm._e(),(_vm.isListeditorActive)?_c('app-listeditor'):_vm._e(),(_vm.isFilemanagerActive)?_c('app-filemanager'):_vm._e(),(_vm.isFileeditorActive)?_c('app-fileeditor'):_vm._e(),(_vm.isSettingsActive)?_c('app-settings'):_vm._e(),(_vm.isTextpickerActive)?_c('app-textpicker'):_vm._e(),(_vm.isModulecreatorActive)?_c('app-modulecreator'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }